import {
  GridsterItemConfig,
  GridsterOptions,
  ResolvedGridsterOptions
} from '../types';

export const DEFAULT_GRIDSTER_OPTIONS: ResolvedGridsterOptions = {
  fixedColWidth: 50,
  fixedRowHeight: 50,
  margin: 10,
  outerMarginTop: null,
  outerMarginRight: null,
  outerMarginBottom: null,
  outerMarginLeft: null,
  minCols: 1,
  maxCols: 100,
  minRows: 1,
  maxRows: 100,
  defaultItemCols: 1,
  defaultItemRows: 1,
  minItemCols: 1,
  minItemRows: 1,
  maxItemCols: 50,
  maxItemRows: 50,
  minItemArea: 1,
  maxItemArea: 2500,
  scrollSensitivity: 10,
  scrollSpeed: 20,
  pushItems: true,
  pushDirections: { north: true, east: true, south: true, west: true },
  disablePushOnDrag: false,
  disablePushOnResize: false,
  swap: true,
  swapWhileDragging: false,
  draggable: {
    enabled: false,
    delayStart: 0,
    dragHandleClass: 'drag-handle',
    ignoreContentClass: 'prevent-drag'
  },
  resizable: {
    enabled: false,
    delayStart: 0,
    handles: { n: true, e: true, s: true, w: true, ne: true, nw: true, se: true, sw: true }
  }
};

const withoutUndefined = <T extends object>(value: T): Partial<T> =>
  Object.fromEntries(Object.entries(value).filter(([, entry]) => entry !== undefined)) as Partial<T>;

export const resolveOptions = (options: GridsterOptions): ResolvedGridsterOptions => ({
  ...DEFAULT_GRIDSTER_OPTIONS,
  ...withoutUndefined(options),
  pushDirections: {
    ...DEFAULT_GRIDSTER_OPTIONS.pushDirections,
    ...withoutUndefined(options.pushDirections ?? {})
  },
  draggable: {
    ...DEFAULT_GRIDSTER_OPTIONS.draggable,
    ...withoutUndefined(options.draggable ?? {})
  },
  resizable: {
    ...DEFAULT_GRIDSTER_OPTIONS.resizable,
    ...withoutUndefined(options.resizable ?? {}),
    handles: {
      ...DEFAULT_GRIDSTER_OPTIONS.resizable.handles,
      ...withoutUndefined(options.resizable?.handles ?? {})
    }
  }
});

export const checkDragHandleClass = (
  target: HTMLElement | null,
  current: HTMLElement,
  dragHandleClass: string,
  ignoreContentClass: string
): boolean => {
  if (!target || target === current) {
    return false;
  }
  if (target.classList.contains(dragHandleClass)) {
    return true;
  }
  if (target.classList.contains(ignoreContentClass)) {
    return false;
  }
  return checkDragHandleClass(target.parentElement, current, dragHandleClass, ignoreContentClass);
};

export const sameLayout = (a: GridsterItemConfig, b: GridsterItemConfig): boolean =>
  a.x === b.x && a.y === b.y && a.cols === b.cols && a.rows === b.rows;
